import React from 'react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <p className="footer-text">
        <em>"Whoever has seen Me has seen the Father."</em>
        <span className="footer-ref">— John 14:9</span>
      </p>
      <p className="footer-small">
        A devotional website for the veneration of the Holy Face of Jesus
      </p>
    </footer>
  );
}
